import { render, staticRenderFns } from "./building_input.vue?vue&type=template&id=11d0ddb8&scoped=true"
import script from "./building_input.vue?vue&type=script&lang=js"
export * from "./building_input.vue?vue&type=script&lang=js"
import style0 from "./building_input.vue?vue&type=style&index=0&id=11d0ddb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0ddb8",
  null
  
)

export default component.exports